import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#3D4F3A] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-16">
          {/* Column 1 - Brand */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/a7c6a7f2-4945-4249-b551-f74c8da4a469.png"
              alt="FIRETRAUMAS"
              className="h-10 sm:h-12 w-auto mb-4"
              loading="lazy"
              decoding="async"
            />
            <p className="text-gray-300 text-xs sm:text-sm leading-relaxed break-words">
              Limpieza profesional post incendio<br />
              Barcelona y Área Metropolitana<br />
              Respuesta rápida · Coordinación con seguros
            </p>
          </div>

          {/* Column 2 - Quick Contact */}
          <div>
            <h3 className="text-xs uppercase tracking-wider text-gray-400 mb-4">Contacto Rápido</h3>
            <div className="space-y-3">
              <a
                href="tel:+34690220944"
                className="flex items-center text-white hover:text-secondary transition-colors text-sm break-words"
              >
                <i className="ri-phone-line mr-2 flex-shrink-0"></i>
                <span>+34 690 22 09 44</span>
              </a>
              <a
                href="https://wa.me/34690220944"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-white hover:text-secondary transition-colors text-sm"
              >
                <i className="ri-whatsapp-line mr-2 flex-shrink-0"></i>
                WhatsApp
              </a>
              <p className="text-gray-300 text-xs sm:text-sm break-words">
                Carrer de Septimània, 49<br />
                08006 Barcelona
              </p>
            </div>
          </div>

          {/* Column 3 - Company */}
          <div>
            <h3 className="text-xs uppercase tracking-wider text-gray-400 mb-4">Empresa</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/empresa" className="text-white hover:text-secondary transition-colors text-xs sm:text-sm">
                  Sobre Nosotros
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-white hover:text-secondary transition-colors text-xs sm:text-sm">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-white hover:text-secondary transition-colors text-xs sm:text-sm">
                  Preguntas Frecuentes
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-white hover:text-secondary transition-colors text-xs sm:text-sm">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Legal */}
          <div>
            <h3 className="text-xs uppercase tracking-wider text-gray-400 mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <a href="#aviso-legal" className="text-white hover:text-secondary transition-colors text-xs sm:text-sm">
                  Aviso Legal
                </a>
              </li>
              <li>
                <a href="#privacidad" className="text-white hover:text-secondary transition-colors text-xs sm:text-sm">
                  Política de Privacidad
                </a>
              </li>
              <li>
                <a href="#cookies" className="text-white hover:text-secondary transition-colors text-xs sm:text-sm">
                  Política de Cookies
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Large Brand Text */}
        <div className="relative overflow-hidden py-8">
          <h2 className="font-serif font-bold text-4xl sm:text-6xl md:text-8xl lg:text-9xl text-[#F7F3EF] opacity-20 text-center break-words">
            FIRETRAUMAS
          </h2>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-600 pt-8 text-center text-xs sm:text-sm text-gray-400">
          <p>© {new Date().getFullYear()} FIRETRAUMAS. Todos los derechos reservados.</p>
          <p className="mt-2">
            <Link 
              to="/contacto"
              className="hover:text-secondary transition-colors"
            >
              Powered by Firetraumas
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}